export default {
  testing: 'Em Testes',
  ready: 'Pronto',
  deployed: 'Implantado',
  obsolete: 'Obsoleto'
}
